import { useState, useEffect } from "react";
import { useGetAllUserRoleQuery } from "src/services/useraccess/UserAccessServices";

const useRoles = () => {
    const [roles, setRoles] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllUserRoleQuery({
        params: ["userRoleName"],
        filterBy: [],
        dateFilter: {},
        orderBy: "createdAt",
        orderByValue: -1,
        isPaginationRequired: false
    });

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setRoles(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { roles, isDataLoading };
};

export default useRoles;
